<template>
    <div id="print" class="big_cat_screen" style="background-color: #275ba9">
        <div class="back_nav" @click="backNav()"><img src="@/assets/back_nav.png"/></div>
        <div class="star_animation" style="display:none">
            <div class="star_score">
                <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
            </div>
        </div>
        <div class="score_content" style="top: 20px;right: 30px;" v-if="totalStarCount > 0">
            <img src="../../assets/star_score_s.png"/><span>{{totalStarCount}}</span>
        </div>
        <audio v-show="false" :src="starAudio" id="star_audio"/>
        <audio v-show="false" :src="greatAudio" id="great_audio"/>

        <div class="star_transition" v-if="showStarTransition && starCount > 0">
            <div class="content">
                <div class="content2">
                    <div class="star_show">
                        <div class="icon1"><img id="star_img_1" style="display: none" :src="getStarImg(1)"/></div>
                        <div class="icon2"><img id="star_img_2" style="display: none" :src="getStarImg(2)"/></div>
                        <div class="icon3"><img id="star_img_3" style="display: none" :src="getStarImg(3)"/></div>
                    </div>
                    <div class="star_score">
                        <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showExitConfirm === 1" class="exit_transition">
            <div class="exit_content">
                <div class="exit_title">完成后，才可以获得星星哦</div>
                <div class="game_action">
                    <div class="game_quit" v-on:click.stop="gameQuitClick">
                        <img src="../../Images/game_quit.png"/>
                        <span>Quit</span>
                    </div>
                    <div class="game_continue" v-on:click.stop="gameContinueClick">
                        <img src="../../Images/game_continue.png"/>
                        <span>Continue</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <div class="div_icon">
                        <img id="success_icon" style="display: none" class="icon" src="@/Images/jili.png"/>
                    </div>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="../../Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>词卡游戏</span>
                            <img src="../../assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 背景 -->
        <div class="word_back" v-if="!isEmpty(objWordCard)">
            <div class="img_show">
                <div class="re-item">
                    <div class="re-item-front" @click="openClick()">
                        <img class="lazy_img" v-lazy="$qiNiuDomainBase + objWordCard.picture" alt="" />
                    </div>

                    <div class="re-item-back" @click="closeClick()">
                        <pre>{{objWordCard.chineseAndEnglishInterpretation}}</pre>
                    </div>
                    <div class="chinese_intro">中</div>
                </div>
            </div>
            <div class="word_audio">
                <div class="word" @click="playAudio(objWordCard.audio)">
                    <div class="audio_playing_white img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                    <img class="img_play" :style="{display: isPlaying ? 'none' : ''}" src="@/assets/volume_white.png" height="30px" width="30px"/>
                    <span>{{objWordCard.word}}</span>
                </div>
                <div id="record_id" class="record">
                    <div class="recording" :style="{display: isRecording ? 'none' : ''}" @click="evaluatingWithType">
                        <img src="../../assets/icon_not_record_audio.png"/>
                    </div>
                    <div class="audio_record_anim recording" :style="{display: isRecording ? '' : 'none'}"
                         @click="endEvaluating"></div>
                </div>
            </div>
            <div class="page_num">
                <span>{{currentIndex + 1}}</span>/{{wordCards.length}}
            </div>
        </div>

        <div id="previous_page" :style="{marginLeft: getStateWidth() + 'px'}" class="previous_page" @click="previousClick" v-show="false"><img src="@/assets/question_left.png" /></div>
        <div id="next_page" class="next_page" @click="nextClick" v-show="false"><img src="@/assets/question_right.png" /></div>

        <audio v-show="false" :src="audioUrl" id="musicMp3" @ended="playEnded" @error="playEnded" />
    </div>
</template>

<script>

    import $ from "jquery";
    import {Indicator, Toast} from "mint-ui";
    import Utils from '@/pages/Program/util2.js';

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                lessonId: 0,
                currentIndex: 0,
                objWordCard: {},
                wordCards: [],
                isRecording: false,
                audioUrl: "",
                finishAudioUrl: "",
                isPlaying: false,
                showExitConfirm: 0,
                showTransition: false,
                starAudio: null,
                starCount: 0,
                showStarTransition: false,
                evaluatingCount: 0,
                totalStarCount: 0,
                wordChanging: false,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
                pingceTimeOut:null
            }
        },
        methods: {
            backNav:function(){
                this.showExitConfirm = 1;
            },
            getStateWidth: function () {
                return this.getCount(this.$store.state.statusheight) > 22 ? 10 : 0;
            },
            gameContinueClick() {
                this.showExitConfirm = 0;
            },
            gameQuitClick() {
                setTimeout(() => {
                    this.cancelEvaluating();
                }, 100);

                this.showExitConfirm = 0;
                this.$router.go(-1);
            },
            nextPageClick: function () {
                setTimeout(() => {
                    this.cancelEvaluating();
                }, 100);

                this.$router.replace({name: "PCardGame", query: {lessonId: this.lessonId}});
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            showStatus:function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            playAudio(audio) {
                let that = this;
                let musicMp3 = document.getElementById('musicMp3');

                if (that.isPlaying) {
                    musicMp3.pause();
                }

                if (that.isRecording) {
                    that.isRecording = false;
                    that.cancelEvaluating();
                }

                that.audioUrl = that.$qiNiuDomainBase + audio;

                setTimeout(() => {
                    that.isPlaying = true;
                    let playPromise = musicMp3.play();

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            let vError = JSON.stringify(e);

                            if (!that.isEmpty(vError) && vError !== "{}") {
                                that.isPlaying = false;
                                window.console.log("播放失败:playAudio:" + vError);
                            }
                        });
                    } else {
                        that.isPlaying = false;
                        window.console.log("播放失败:playAudio");
                    }
                }, 200);
            },
            playEnded() {
                let that = this;
                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();

                if (that.isPlaying) {
                    this.isPlaying = false;

                    // 不自动评测
                    // if (!that.isRecording) {
                    //     that.isRecording = true;
                    //
                    //     // 播放完成自动开始评测
                    //     setTimeout(() => {
                    //         that.evaluatingWithType();
                    //     }, 500);
                    // }
                }
            },
            evaluatingWithType() {
                let that = this;
                let vPlatform = that.judgePlatform();
                let wordCard = that.wordCards[that.currentIndex];
                let type = wordCard.type === 4 ? 2 : 1;
                that.isRecording = true;
                that.showPreviousNext();
                that.playEnded();

                if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    // document.location = "readingclubapp:evaluatingWithType:" + type + ":" + wordCard.word;

                    if (that.pingceTimeOut != null) {
                        clearTimeout(that.pingceTimeOut);
                        that.pingceTimeOut = null;
                    }

                    that.pingceTimeOut = setTimeout(function () {
                        that.evaluatingResultForTimeout(1, 1);
                    }, 5000);
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    // window.note.evaluatingWithType(type, wordCard.word);

                    if (that.pingceTimeOut != null) {
                        clearTimeout(that.pingceTimeOut);
                        that.pingceTimeOut = null;
                    }

                    that.pingceTimeOut = setTimeout(function () {
                        that.evaluatingResultForTimeout(1, 1);
                    }, 4000);
                }
            },
            endEvaluating() {
                let that = this;
                that.isRecording = false;
                let vPlatform = that.judgePlatform();

                setTimeout(function () {
                    if (vPlatform === 3) {
                        // 3-app平台IOS平台
                        // document.location = "readingclubapp:endEvaluating";

                        if (that.pingceTimeOut != null) {
                            clearTimeout(that.pingceTimeOut);
                            that.pingceTimeOut = null;
                        }

                        that.pingceTimeOut = setTimeout(function () {
                            that.evaluatingResultForTimeout(1, 1);
                        }, 800);
                    } else if (vPlatform === 4) {
                        // 4-app平台android平台
                        window.note.endEvaluating();
                    }
                }, 800);
            },
            evaluatingResult(result) {
                let that = this;
                that.evaluatingResultForTimeout(result, 0);
            },
            evaluatingResultForTimeout(result, isTimeout) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3 && isTimeout !== 1) {
                    // 3-app平台IOS平台
                    return;
                }

                // 返回测评结果处理，随机给2、3颗星
                that.starCount = that.getRandomInt(2, 3);
                that.showStarTransition = true;
                that.isRecording = false;
                that.showPreviousNext();

                if (that.starCount < 1 && that.evaluatingCount === 0) {
                    // try again
                    that.closeStarTransition();
                    that.evaluatingCount += 1;

                    that.starAudio = that.getProgramAudioUrl(that.starCount);
                    setTimeout(() => {
                        const starAudio = document.getElementById('star_audio');
                        starAudio.play();
                    }, 200);

                    that.objWordCard = that.wordCards[that.currentIndex];
                    let wordAudio = that.objWordCard.audio;

                    setTimeout(function () {
                        if (!that.isEmpty(wordAudio)) {
                            that.playAudio(wordAudio);
                        }
                    }, 2800);
                    return;
                }

                setTimeout(() => {
                    for(let i = 1; i <= 3; i++) {
                        $("#star_img_" + i).show(200 + i*100, function(){
                            if (i === 3) {
                                if (that.starCount > 0) {
                                    that.starAudio = that.getProgramAudioUrl(that.starCount);

                                    setTimeout(() => {
                                        const starAudio = document.getElementById('star_audio');
                                        starAudio.play();
                                    }, 200);
                                }

                                setTimeout(() => {
                                    that.showStarTransition = false;
                                    let starAnimation = $(".star_animation");
                                    starAnimation.show();
                                    starAnimation.animate({top:"20px", right:"30px"}, 500, function() {
                                        starAnimation.hide();
                                        starAnimation.css({top:"", right:""});

                                        if (that.starCount > 0) {
                                            that.addStar(that.starCount);
                                        }
                                    });
                                }, 800);
                            }
                        });
                    }

                    setTimeout(() => {
                        that.closeStarTransition();
                        that.evaluatingCount = 0;

                        // 下一题
                        if (that.currentIndex < that.wordCards.length - 1) {
                            that.nextClick();
                        } else {
                            //  最后一题
                            that.showTransition = true;

                            setTimeout(function () {
                                const greatAudio = document.getElementById('great_audio');
                                greatAudio.play();
                                $("#success_icon").show(800, function(){});
                            }, 20);

                            Utils.$emit('setStarCount', '3');
                        }
                    }, 3000);
                }, 200);
            },
            cancelEvaluating() {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    // document.location = "readingclubapp:cancelEvaluating";
                    if (that.pingceTimeOut != null) {
                        clearTimeout(that.pingceTimeOut);
                        that.pingceTimeOut = null;
                    }
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.note.cancelEvaluating();
                }
            },
            evaluatingError: function (errorCode) {
                let that = this;
                window.console.log("错误码：" + errorCode);
                that.evaluatingResult(0);
            },
            addStar: function(starCount) {
                let that = this;
                let url = "englishProgram/addStar/" + that.lessonId + "/" + starCount;

                this.$axios.get(url).then((response) => {
                    that.totalStarCount = response.data;
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            sentenceStartRecordAnimation() {
                this.isRecording = true;

            },
            sentenceEndRecordAnimation() {
                this.isRecording = false;
            },
            sentenceCloseIndicator() {
                Indicator.close();
            },
            closeStarTransition() {
                this.showStarTransition = false;
            },
            getStarImg(count) {
                let that = this;
                return count <= that.starCount ? require('@/assets/star_score_s.png') : require('@/assets/star_score_n.png');
            },
            openClick() {
                $(".re-item-front").addClass("open");
                $(".re-item-back").addClass("open");
                $(".chinese_intro").hide(500);
            },
            closeClick() {
                $(".re-item-front").removeClass("open");
                $(".re-item-back").removeClass("open");
                $(".chinese_intro").show(1000);
            },
            nextClick: function() {
                let that = this;

                if (that.wordChanging) {
                    return;
                }

                that.wordChanging = true;
                that.showPreviousNext();

                if (that.currentIndex < that.wordCards.length - 1) {
                    setTimeout(function () {
                        that.closeClick();

                        that.currentIndex += 1;
                        that.objWordCard = that.wordCards[that.currentIndex];
                        let wordAudio = that.objWordCard.audio;
                        that.wordChanging = false;
                        that.showPreviousNext();

                        setTimeout(function () {
                            if (!that.isEmpty(wordAudio)) {
                                that.playAudio(wordAudio);
                            }
                        }, 200);
                    }, 300);
                } else {
                    that.wordChanging = false;
                    that.showPreviousNext();
                }
            },
            previousClick() {
                let that = this;

                if (that.wordChanging) {
                    return;
                }

                that.wordChanging = true;
                that.showPreviousNext();

                if (that.currentIndex > 0) {
                    setTimeout(function () {
                        that.currentIndex -= 1;
                        that.objWordCard = that.wordCards[that.currentIndex];
                        let wordAudio = that.objWordCard.audio;
                        that.wordChanging = false;
                        that.showPreviousNext();

                        setTimeout(function () {
                            if (!that.isEmpty(wordAudio)) {
                                that.playAudio(wordAudio);
                            }
                        }, 200);
                    }, 300);
                }
            },
            showPreviousNext() {
                let that = this;

                if (!that.isRecording && !that.wordChanging) {
                    let previousPage = $("#previous_page");
                    let nextPage = $("#next_page");

                    if (that.currentIndex <= 0) {
                        previousPage.hide();
                    } else {
                        previousPage.show();
                    }

                    if (that.currentIndex < that.wordCards.length - 1) {
                        nextPage.show();
                    } else {
                        nextPage.hide();
                    }
                } else {
                    $("#previous_page").hide();
                    $("#next_page").hide();
                }
            },
        },
        created() {
            let that = this;
            // 客户端调用方法组
            window.sentenceStartRecordAnimation = that.sentenceStartRecordAnimation;
            window.sentenceEndRecordAnimation = that.sentenceEndRecordAnimation;
            window.sentenceCloseIndicator = that.sentenceCloseIndicator;
            window.evaluatingResult = that.evaluatingResult;
            window.evaluatingError = that.evaluatingError;
        },
        beforeCreate() {
            let vlessonId = parseInt(this.$route.query.lessonId);
            let url = "englishProgram/getSpeakingWordCardInLesson/" + vlessonId;
            let that = this;

            this.$axios.get(url).then((response) => {
                let vWordCard = response.data;
                that.wordCards = vWordCard.coreWordList;
                that.lessonId = vlessonId;
                that.currentIndex = 0;
                that.totalStarCount = vWordCard.totalStarCount;

                that.hideStatusAndStopAudio();

                let wordAudio = "";
                if (!that.isEmpty(that.wordCards)) {
                    that.objWordCard = that.wordCards[0];
                    wordAudio = that.objWordCard.audio;
                }

                that.showPreviousNext();

                setTimeout(() => {
                    transformView();

                    var t;
                    clearTimeout(t);
                    t = setTimeout(function () {
                        window.PLessonRefreshData = 0;

                        if (!that.isEmpty(wordAudio)) {
                            that.playAudio(wordAudio);
                        }
                    }, 200);
                }, 200);
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .word_back {
        position: absolute;
        width: calc(190vmin - 104*1.9px);
        height: calc(100vmin - 104px);
        top: 74px;
        bottom: 30px;
        background-color: #0000006a;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        display: flex;
    }
    .word_back .img_show {
        margin: 30px;
    }
    .word_back .img_show img {
        width: calc(100vmin - 164px);
        height: calc(100vmin - 164px);
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }

    .word_back .word_audio {
        width: calc(90vmin - 123.6px);
        height: calc(100vmin - 104px);
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        align-content: center;
    }
    .word_back .word {
        width: calc(90vmin - 123.6px);
        display: flex;
        justify-content: center;
    }
    .word_back .word .img_play {
        width: 30px;
        height: 30px;
        min-width: 30px;
        margin-right: 5px;
        margin-top: 1px;
    }
    .word_back .word span {
        max-width: calc(90vmin - 88px);
        color: white;
        font-size: 25px;
        line-height: 28px;
        font-weight: bold;
        font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI", "Microsoft YaHei", "微软雅黑", sans-serif;
        text-align: center;
    }
    .word_back .record {
        width: calc(90vmin - 123.6px);
        display: flex;
        justify-content: center;
        margin-top: 50px;
        font-size: 0;
    }
    .word_back .record .recording img {
        width: 70px;
        height: 70px;
    }
    .audio_record_anim {
        width: 70px; /*宽高尺寸任意增减*/
        height: 70px;
        background: url(../../assets/record_audio_anim.png) no-repeat;
        background-size: 1000% 100%;
        -webkit-animation: line-slow 0.8s steps(9) infinite;
        animation: line-slow 0.8s steps(9) infinite;
    }
    @keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }
    @-webkit-keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }

    .word_back .page_num {
        position: absolute;
        bottom: 30px;
        right: 30px;
        color: white;
        text-align: center;
        font-size: 15px;
    }
    .word_back .page_num span {
        font-size: 18px;
        font-weight: bold;
    }


    /*确认按钮样式*/
    .big_cat_screen .exit_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .big_cat_screen .exit_content {
        position:relative;
    }
    .big_cat_screen .exit_content .exit_title {
        color: white;
        font-size: 18px;
        text-align: center;
        margin-bottom: 50px;
    }
    .big_cat_screen .exit_content .game_action .game_quit {
        display: inline-block;
        margin-right: 100px;
    }
    .big_cat_screen .exit_content .game_action .game_continue {
        display: inline-block;
    }
    .big_cat_screen .exit_content .game_action .game_quit img, .big_cat_screen .exit_content .game_action .game_continue img {
        display: block;
        width: 70px;
        margin-bottom: 10px;
    }
    .big_cat_screen .exit_content .game_action .game_quit span, .big_cat_screen .exit_content .game_action .game_continue span {
        display: block;
        text-align: center;
        font-size: 20px;
        color: white;
    }

    .big_cat_screen .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .big_cat_screen .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .big_cat_screen .transition .content2 {
        text-align: center;
    }

    .big_cat_screen .transition .content3 {
        text-align: center;
    }
    .big_cat_screen .transition .content .div_icon {
        margin-bottom: 10px;
        width: 100%;
        height: 135px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .big_cat_screen .transition .content .div_icon .icon {
        width: 205px;
        height: 135px;
    }
    .big_cat_screen .transition .content .text {
        width: 100%;
    }
    .big_cat_screen .transition .content .text span {
        display: block;
        text-align: center;
    }
    .big_cat_screen .transition .content .text .success_tip {
        font-size: 20px;
    }
    .big_cat_screen .transition .content .star {
        height: 35px;
    }
    .big_cat_screen .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .big_cat_screen .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .big_cat_screen .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }

    .re-item {
        width: calc(100vmin - 164px);
        height: calc(100vmin - 164px);
        position: relative;
    }

    .re-item .chinese_intro {
        position: absolute;
        bottom: 10px;
        right: 10px;
        background-color: rgba(0, 0, 0, 0.60);
        border-radius: 3px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        padding-left: 5px;
        padding-right: 5px;
        font-size: 12px;
        color: white;
        z-index: 201;
    }

    .re-item-front,
    .re-item-back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: transparent;
        backface-visibility: hidden;
        -webkit-transition: all 1.5s;
        -moz-transition: all 1.5s;
        -ms-transition: all 1.5s;
        -o-transition: all 1.5s;
        overflow: hidden;
    }

    .re-item-back {
        position: relative;
        transform: rotateY(-180deg);
        -webkit-transform: rotateY(-180deg);
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        text-align: center;
    }
    .re-item-back pre {
        padding-left: 10px;
        padding-right: 10px;
        font-weight: bold;
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .re-item-front.open {
        transform: rotateY(180deg);
        cursor: default;
        transition: transform 1s;
    }
    .re-item-back.open {
        transform: rotateY(0deg);
        cursor: default;
        transition: transform 1s;
    }

    .previous_page {
        position: absolute;
        z-index: 1000;
        top: calc(50vmin - 30px);
        left: 0;
    }
    .next_page {
        position: absolute;
        z-index: 1000;
        top: calc(50vmin - 30px);
        right: 0;
    }
    .previous_page img, .next_page img {
        width: 60px;
        height: 60px;
    }

</style>
